import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'

import DatePick from 'vue-date-pick'

export default {
    name: 'CustomerProfile',
    created,
    data,
    methods,
    mounted,
    components: {
        DatePick
    }
}
